import * as React from "react";
import { Card, CardContent, Typography, CardActions, Button, Box, FormControl, FormControlLabel, Radio, InputLabel, Alert, } from "@mui/material";
import { Formik, FormikProps, Form, } from "formik";
import TextField from '@mui/material/TextField';
import * as Yup from 'yup';
import { Link, useMatch } from "react-router-dom";
import RadioGroup from '@mui/material/RadioGroup';
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { useAppDispatch } from "../../../store/store";
import { priceLevelActionSelector, priceLevelGetDataById, priceLevelUpdateData } from "../../../store/slices/priceLevelActionSlice";
import { PriceLevel } from "../../../types/pricelevel.type";
import Loader from "../../component/Loader";
import Checkbox from '@mui/material/Checkbox';

type PriceLevelEditPageProps = {
  //
};

const PriceLevelEditPage: React.FC<any> = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const priceLevelActionReducer = useSelector(priceLevelActionSelector);
  const match = useMatch("/pricelevel/edit/:id");
  const initialValues: PriceLevel = { id: "", priceLevelDesc: "", priceGroup: true, active: true };
 
  React.useEffect(() => {
    let id = match?.params.id;
    dispatch(priceLevelGetDataById(id!));
  }, [])


  const showForm = ({ values, setFieldValue, isSubmitting, touched, errors, handleChange, handleBlur }: FormikProps<PriceLevel>) => {
    return (
      <Form>
        <Card>
          <CardContent sx={{ padding: 4 }}>
            <Typography gutterBottom variant="h5">
              Edit Price Level
            </Typography>

            <TextField id="priceLevelDesc"
              style={{ marginTop: 16 }}
              fullWidth
              disabled={true}
              variant="outlined"
              label={t('pricelevelId')}
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.id}
              helperText={
                errors.id && touched.id
                  ? errors.id
                  : ''
              }
              error={
                errors.priceLevelDesc && touched.priceLevelDesc
                  ? true
                  : false
              } />

            <TextField id="priceLevelDesc"
              style={{ marginTop: 16 }}
              fullWidth
              variant="outlined"
              label={t('Description')}
              onChange={handleChange}
              onBlur={handleBlur}
              value={values.priceLevelDesc}
              helperText={
                errors.priceLevelDesc && touched.priceLevelDesc
                  ? errors.priceLevelDesc
                  : ''
              }
              error={
                errors.priceLevelDesc && touched.priceLevelDesc
                  ? true
                  : false
              } />
            <FormControlLabel
              control={<Checkbox
                id="priceGroup"
                checked={values.priceGroup}
                onChange ={handleChange}
                value={values.priceGroup}
             />} label="Price Group" />

            <FormControl component="fieldset" style={{ marginTop: 16 }} fullWidth>
              <RadioGroup row name="active" onChange={(event) => { setFieldValue("active", event.currentTarget.value === "true" ? true : false) }} value={values.active}>
                <FormControlLabel control={<Radio />} value={true} label={t('active')} />
                <FormControlLabel control={<Radio />} value={false} label={t('inactive')} />
              </RadioGroup>
            </FormControl>

            {priceLevelActionReducer.isError && <Alert severity="error">{priceLevelActionReducer.message}</Alert>}

          </CardContent>
          <CardActions>
            <Button
              fullWidth
              variant="contained"
              color="primary"
              type="submit"
              sx={{ marginRight: 1 }}
              disabled={priceLevelActionReducer.isFetching}
            >
              {t('btnEdit')}
            </Button>
            <Button component={Link} to="/pricelevel" variant="outlined" fullWidth>
              {t('btnCancel')}
            </Button>
          </CardActions>
        </Card>
      </Form>
    );
  };

  const inputRequired = t('inputRequired');

  const validationSchema = Yup.object().shape({
    id: Yup.string().required(inputRequired),
    priceLevelDesc: Yup.string().required(inputRequired),
  });


  if (priceLevelActionReducer.isFetching) {
    return <><Loader /></>
  }

  return (
    <Box>
      <Formik
        validationSchema={validationSchema}
        enableReinitialize={true}
        initialValues={priceLevelActionReducer.result ? priceLevelActionReducer.result! : initialValues}
        onSubmit={(values, { setSubmitting }) => {
          dispatch(priceLevelUpdateData(values));
          setSubmitting(false);
        }}
      >
        {(props: any) => showForm(props)}
      </Formik>
    </Box>
  );
};

export default PriceLevelEditPage;
